import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";

import HeaderCountry from "../components/HeaderCountry";
import OverviewCountry from "../components/OverviewCountry";
import BestCountry from "../components/BestCountry";
import PlanningTrip from "../components/PlanningTrip";
import Clients from "../components/Clients";
import Footer from "../components/Footer";

interface DestinationDetail {
  metaTitle: string;
  metaDescription: string;
  metaKeyword: string;
  [key: string]: any;
}

const STATIC_TOKEN =
  "N2o0ZjZlZVFBRUxVL1laanlBczQ0UT09OjrGQtx134tUoB8T7vu8HoWyMTN3NjlhZWQrNDMyZGpydGVRR3VIQT09OjqOhX0XNADMMEojPyPpiZlA";

const CountryDestination: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [metaData, setMetaData] = useState<DestinationDetail | null>(null);

  useEffect(() => {
    const fetchCountryMeta = async () => {
      try {
        const response = await axios.post(
          "https://travelnrelax.com/tadmin/api/pages/CountryPageDetails",
          { countryId: id },
          {
            headers: {
              token: STATIC_TOKEN,
              "Content-Type": "application/json",
            },
          }
        );

        if (
          response.data.success &&
          response.data.data.destinationDetails?.[0]
        ) {
          setMetaData(response.data.data.destinationDetails[0]);
        }
      } catch (err) {
        console.error("Error fetching country metadata", err);
      }
    };

    if (id) {
      fetchCountryMeta();
    }
  }, [id]);

  return (
    <div>
      <Helmet>
        <title>
          {metaData?.metaTitle || "Explore Destination | Travel n Relax"}
        </title>
        <meta
          name="title"
          content={metaData?.metaTitle || "Explore Destination"}
        />
        <meta
          name="description"
          content={
            metaData?.metaDescription || "Discover amazing places with us."
          }
        />
        <meta
          name="keywords"
          content={metaData?.metaKeyword || "travel, tourism, destinations"}
        />
        <link
          rel="canonical"
          href={`https://travelnrelax.com/country/${id}/`}
        />
      </Helmet>

      <HeaderCountry />
      <OverviewCountry />
      <div className="mt-8">
        <BestCountry />
      </div>
      <PlanningTrip
        headingplanning="Where to next?"
        paragraph="We’ll create a vacation you’ll remember forever."
      />
      <Clients />
      <Footer />
    </div>
  );
};

export default CountryDestination;
